'use client';
import Button from '@gds/Button/Button';
import { Typography } from '@gds/Typography/Typography';

import { PrefetchLink } from '@shared-components/PrefetchLink/PrefetchLink';

import { OptionalPageBuilderProps } from '../../Entities/PageBuilder.entity';

import { CollapsibleInterlinking } from './CollapsibleInterLinking/CollapsibleInterlinking';
import { InterlinkingContent } from './Entities/InterLinking.entity';

import styles from './InterLinking.module.css';

export const Interlinking = (interlinking: OptionalPageBuilderProps<InterlinkingContent>) => {
  if (interlinking?.variant?.[0]?.codename === 'collapsible') {
    return <CollapsibleInterlinking {...interlinking} locale={interlinking.locale || 'uk'} />;
  }
  return (
    <>
      {interlinking.interlinkingItems.map(interlinkingItem => (
        <div className={styles.interlinking} key={interlinkingItem.heading}>
          <div className={styles.title}>
            <Typography variant="h2">{interlinkingItem.heading}</Typography>
          </div>
          {interlinkingItem.linkBlocks && (
            <div className={styles.layout}>
              {interlinkingItem.linkBlocks.map(linkBlock => (
                <div className={styles.list} key={linkBlock.heading}>
                  <Typography className={styles.blockHeader} variant="subheading3">
                    {linkBlock.heading}
                  </Typography>
                  {linkBlock.cta?.map?.((cta, index) => {
                    if (index > 5) return null;

                    return (
                      <PrefetchLink href={cta.link ?? '/'} key={cta.ctaText}>
                        <Button variant="link" className={styles.links}>
                          {cta.ctaText}
                        </Button>
                      </PrefetchLink>
                    );
                  })}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </>
  );
};

Interlinking.displayName = 'Interlinking';
